import { tv } from '@pcln/horizon'

export const tripActivityVariants = tv({
  slots: {
    heading: 'text-heading3 sm:text-heading2',
    recentSearchesHeading: 'text-heading3',
    similarHotelsHeading: 'text-heading4',
    wrapperSlot: 'mb-4 flex items-start justify-between',
    viewAllButton: '',
  },
  variants: {
    useSmallerHeading: {
      true: {
        heading: 'text-heading4 sm:text-heading3',
        recentSearchesHeading: 'text-heading4 sm:text-heading3',
        similarHotelsHeading: 'text-heading5 sm:text-heading4',
      },
    },
    isViewAllButtonSeti: {
      true: {
        wrapperSlot: 'items-center justify-start gap-3',
      },
    },
  },
})
